import { styled } from 'styled-components';
import { getCDNImageUrl } from '@/helpers/cdn';
import { device } from '@/styles/helpers';
import type { TLogoHeader } from './FormLogoHeader';

interface IScFormLogoHeaderProps {
  logoTheme?: TLogoHeader;
}

const logo = getCDNImageUrl('/icon-img/logo.svg');
const logoDark = getCDNImageUrl('/icon-img/logoDark.svg');

interface IScFormTextHeaderProps {
  $isSmallSize?: boolean;
}

export const ScFormTextHeader = styled.div<IScFormTextHeaderProps>`
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  & > h2 {
    font-weight: bold;
    font-size: ${({ $isSmallSize }) => ($isSmallSize ? '28px' : '32px')};
    line-height: ${({ $isSmallSize }) => ($isSmallSize ? '36px' : '40px')};
    text-transform: uppercase;
    text-align: center;
    letter-spacing: 0.96px;

    @media (${device.mobile}) {
      font-size: ${({ $isSmallSize }) => ($isSmallSize ? '20px' : '28px')};
      line-height: ${({ $isSmallSize }) => ($isSmallSize ? '26px' : '36px')};
      text-align: center;
      letter-spacing: 0.84px;
      word-break: break-word;
    }
  }

  & > .description {
    text-align: center;
    font-size: 16px;
    line-height: 24px;
  }
`;

export const ScFormLogoHeader = styled.div<IScFormLogoHeaderProps>`
  margin-block: 8px 24px;
  display: grid;
  place-items: center;
  width: 100%;
  height: 24px;
  background: ${({ logoTheme }) =>
    `url(${logoTheme === 'black' ? logoDark : logo}) center / contain no-repeat`};
`;
